module.exports = __webpack_public_path__ + "img/engagement-insights-no-views-9597bccb78a2dbf031272d1093acd543.svg";